var helper = require('../../helper');
require('moment');
require('jquery-ui');

var TicketCalendarOfContractorContactController = function(datatable) {

    this.datatable = datatable;
    this.contactId = $('#js-contact-id').data('contact');
    this.calendar = $('#tickets-calendar-contractor-contact');
    this.$modal = $('#modal-ticket-from-calendar');
    this.$updateButton = this.$modal.find('.modal-submit-button');
    this.$deleteButton = this.$modal.find('.js-modal-delete-button');
    this.$goToContractorContactCalendar = $('.js-ticket-go-to-contractor-contact-calendar');

    this.EditModalFormController = new (require('../../services/modals/ModalFormController'))(this.$modal);
    this.TicketCalendarController = new (require('../../modules/tickets/TicketCalendarController'))();
    this.ToastrController = new (require('../../services/ToastrController'));

    var self = this; // Needed for using all constructor variables inside this function, note the difference -> no "this" but "var" at the beginning

    (function()
    {

        self.$updateButton.click(function(e){
            self.updateModel(e);
        });

        self.$deleteButton.click(function(e){
            self.deleteModel(this, e);
        });

    }());


}

TicketCalendarOfContractorContactController.prototype.render = function(message, title) {

    var self = this;

    this.calendar.fullCalendar('destroy');

    this.calendar.fullCalendar({
        events: helper.getOrigin() + "/api/tickets/contractor-contact/" + this.contactId,
        header: {
            left: '',
            center: 'prev title next',
            right: 'listWeek,month,agendaWeek,agendaDay'
        },
        defaultView: 'agendaDay',
	    timeFormat: 'HH:mm',
	    minTime: '06:00',
        firstDay: 1,
        editable: false,
        droppable: false,

	    eventRender: function(event, element) {
		    element.find('.fc-list-item-time').html(event.ticket_status)
		    element.find('.fc-list-item-title').append('<div>' + event.calendar_description + '</div>');
		    element.find('.fc-content').append('<div>' + event.calendar_description + '</div>');
	    },

	    eventClick: function (event) {

            var  fieldsInput = ['id', 'book_in_day', 'book_in_time_from', 'book_in_time_to'],
		         fieldsText = ['contractor_user', 'contractor_decision', 'calendar_description', 'ticket_status', 'title'];

            self.getModel(event.id, function(data){
	            self.EditModalFormController.loadTicketData(data, fieldsInput, fieldsText);
	            // self.EditModalFormController.beforeShowTicketForContractor(data); // Stuart deiced that contractor contacts can always change the status
                self.EditModalFormController.showModal(); // on CALLBACK!
            });

        },
    });

    self.datatable.reload();

	self.$goToContractorContactCalendar.on('change', function(e) {
		var contactId = $(this).val();

		if(contactId > 0){
            //TODO verify why is this used here, and for what? ask client about usability of this feature
            //window.location.href = helper.getOrigin() + "/tickets/contractor-contact/" + contactId;
            window.location.href = helper.getOrigin() + "/contractors/contacts/" + contactId + "/calendar";
		}
	});
}

TicketCalendarOfContractorContactController.prototype.changeBookInDates = function(event) {
	this.TicketCalendarController.changeBookInDates(event, this.calendar);
}

TicketCalendarOfContractorContactController.prototype.deleteModel = function(deleteButton, e) {

    var msg = 'Are you sure you want to delete this?';

    if (!confirm(msg)) {
        e.preventDefault();
        return;
    }

    e.preventDefault();

	var ticketId = $(deleteButton).data('ticket')

    this.TicketCalendarController.deleteModel(this, this.EditModalFormController, ticketId);
}

TicketCalendarOfContractorContactController.prototype.updateModel = function(e) {
    e.preventDefault();

    var self = this;

	var serializedData = self.EditModalFormController.getFieldsData();

	$.ajax(
			{
				type: 'POST',
				data: serializedData,
				url: helper.getOrigin() + "/api/tickets/update-from-contractor-calendar/" + self.TicketCalendarController.getFormData(serializedData).id,
				dataType: 'json',

				success: function (data) {
					self.EditModalFormController.clearModal();
					self.EditModalFormController.closeModal();
					if (data.status == 'error') {
						this.ToastrController.showDanger(data.message);
					} else {
						self.ToastrController.showSuccess(data.message);
						self.render();
					}
				},

				error: function (data) {

					var errors = data.responseJSON;

					// Now display all errors from validation
					self.EditModalFormController.displayErrors(errors);

				}
			});
}

TicketCalendarOfContractorContactController.prototype.getModel = function(modelId, callbackSuccess) {
    return this.TicketCalendarController.getModel(modelId, callbackSuccess);
}

TicketCalendarOfContractorContactController.prototype.getFormData = function(unindexed_array) {
    return this.TicketCalendarController.getFormData(unindexed_array);
}

TicketCalendarOfContractorContactController.prototype.clearModal = function() {
    this.EditModalFormController.clearModal();
}

TicketCalendarOfContractorContactController.prototype.showModal = function() {
    this.EditModalFormController.showModal();
}

TicketCalendarOfContractorContactController.prototype.closeModal = function() {
    this.EditModalFormController.closeModal();
}

module.exports = TicketCalendarOfContractorContactController;
